import {
  $get, $post, $JsonPost, jes,
} from '@/utils/axios-request';

import Vue from 'vue';

class Devisive {
  // 决胜 主页
  public async index(): Promise<any> {
    // 调用基本数据 由 接口自主承担
    const postData: any = {
      currentNodeId: window.LS.get('jse_data').currentNodeId,
      nodeGroupId: window.LS.get('jse_data').nodeGroupId,
      processInstanceId: window.LS.get('jse_data').processInstanceId,
    };
    return await $get(`${jes}/index/api/v1/index`, postData);
  }

  // 根据用户基本信息获取决胜相关信息
  public async getInfo(): Promise<any> {
    // 调用基本数据 由 接口自主承担
    const postData: any = {
      refId: window.LS.get('basicData').refID,
      userId: window.LS.get('basicData').userID,
      classCode: '123',
      gradeID: window.LS.get('basicData').gradeID,
      loginName: window.LS.get('basicData').loginName,
      moduleId: window.LS.get('basicData').moduleID,
      userName: window.LS.get('basicData').loginName,
    };
    return await $get(`${jes}/login/api/v1/getInfo`, postData);
  }

  // 前20名排行榜列表
  public async rankingList(postData: any): Promise<any> {
    return await $get(`${jes}/rankingList/api/v1/rankingList`, postData);
  }

  // 学习记录列表
  public async studyRecordList(postData: any): Promise<any> {
    return await $get(`${jes}/studyRecord/api/v1/studyRecordList`, postData);
  }

  // 学习任务列表
  public async studyTaskList(postData: any): Promise<any> {
    return await $get(`${jes}/studyTask/api/v1/studyTaskList`, postData);
  }

  // 红宝书详情
  public async studyGuideDetail(postData: any): Promise<any> {
    return await $get(`${jes}/studyGuide/api/v1/studyGuideDetail`, postData);
  }

  // 红宝书树形列表
  public async studyGuideTreeList(postData: any): Promise<any> {
    return await $get(`${jes}/studyGuide/api/v1/studyGuideTreeList`, postData);
  }

  // 学习目录(所有做过的节点)
  public async studyDirectoryList(postData: any): Promise<any> {
    return await $get(`${jes}/studyRecord/api/v1/studyDirectoryList`, postData);
  }

  // 学历分析 eachars
  public async getStudyStatisticAnalysis(postData: any): Promise<any> {
    return await $get(`${jes}/studyRecord/api/v1/getStudyStatisticAnalysis`, postData);
  }

  // 学习分析目录(所有做过和跳过的节点)
  public async studyAnalysisDirectoryList(postData: any): Promise<any> {
    return await $get(`${jes}/studyRecord/api/v1/studyAnalysisDirectoryList`, postData);
  }

  // 学前评测/学后评测统计结果
  public async getEvaluateCalculationDate(postData: any): Promise<any> {
    return await $get(`${jes}/studyRecord/api/v1/getEvaluateCalculationDate`, postData);
  }

  // 测试统计分析
  public async getTestStatisticAnalysis(postData: any): Promise<any> {
    return await $get(`${jes}/studyRecord/api/v1/getTestStatisticAnalysis`, postData);
  }

  // public async rankingList(postData:any): Promise<any> {
  //     // 调用基本数据 由 接口自主承担
  //     return await $get(jes+'/rankingList/api/v1/rankingList', postData);
  // }
  // 学习分析-扩展练习
  public async extTraining(postData: any): Promise<any> {
    return await $get(`${jes}/startLearning/api/extTraining`, postData);
  }
}
export default new Devisive();
